module.exports = __webpack_public_path__ + "dashboard/img/lock.845289b6785da9145acbd3cef4496b82.svg";